import { IInference, IAstNode } from './typings';
import { TypeGenerator, isBoolean } from '../utils/type';
import { InferenceError } from '../errors';



export function inferenceLogicAndComparison(inference: IInference, astNode: IAstNode) {
    const leftType = inference(astNode.left)!;
    const rightType = inference(astNode.right)!;
    const token = astNode.token;

    if (!isBoolean(leftType, false) || !isBoolean(rightType, false)) {
        throw new InferenceError('comparison-value-error', '非布尔类型不能参与逻辑运算', token.position);
    }

    return TypeGenerator.Boolean();
}
